module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_11.77906e19.jpg";